import LBox from "@components/LBox";
import LPressable from "@components/LPressable";
import LIcon from "@components/LIcon";
import { Platform } from "react-native";
import { SCREEN_WIDTH } from "../../config";
import { theme } from "@theme";
import { AccessDetailsDismiss } from "../../types";

const Handle = ({ onDismiss }: { onDismiss?: AccessDetailsDismiss }) => {
  if (Platform.OS === "web" && onDismiss) {
    return (
      <LPressable
        sentryEventName="AccessDetail.DismissHandle"
        onPress={() => onDismiss?.()}
      >
        <LBox
          width={SCREEN_WIDTH}
          alignItems="center"
          justifyContent="center"
          mb="s4"
          py="s2"
          backgroundColor={[
            "whiteTranslucent10",
            "whiteTranslucent20",
            "whiteTranslucent10",
          ]}
          gradientDirection="horizontal"
        >
          <LIcon
            colors={{ color: theme.colors.whiteTranslucent20 }}
            name="chevron"
            size={18}
          />
        </LBox>
      </LPressable>
    );
  }

  return (
    <LBox
      width={40}
      height={4}
      borderRadius="m"
      backgroundColor="whiteTranslucent50"
      alignSelf="center"
    />
  );
};
export default Handle;
